<div class="p-1">
  <mat-accordion>
    @for (assetClass of assetClassConfigs; track assetClass) {
      <mat-expansion-panel
        (opened)="panelChangedTo(assetClass.key)"
        [ngClass]="{ 'asset-class-active': isAssetClassActive(assetClass) }"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ assetClass.name }}
            <span class="count-lbl">({{ getTotalCount(assetClass.key) }})</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <!-- Reusable filter field template -->
        @for (filter of assetClass.filters; track filter) {
          <mat-form-field
            appearance="outline"
            class="w-100"
            [ngClass]="{ 'filter-active': isFilterActive(filter.key) }"
          >
            <mat-label
              >{{ filter.label }}
              <span class="count-lbl"
                >({{ getFilterTotalCount(filter.totalCountKey) }})</span
              ></mat-label
            >
            <mat-select
              [(ngModel)]="currentFilters.filters[filter.key]"
              (ngModelChange)="onFilter()"
            >
              <!-- Grouped options for Fixed Income -> category_desc -->
              @if (
                assetClass.key === "Fixed Income" &&
                filter.key === "category_desc"
              ) {
                @for (group of categoryDescGroups; track group) {
                  <mat-optgroup [label]="group.groupName">
                    @for (option of group.options; track option) {
                      <mat-option [value]="option.id">
                        {{ getSecondPart(option.name) }}
                        <span class="count-lbl">({{ option.count || 0 }})</span>
                      </mat-option>
                    }
                  </mat-optgroup>
                }
              } @else {
                @for (
                  option of getFilterOptions(filter.optionsKey);
                  track option
                ) {
                  <mat-option [value]="option.id">
                    {{ option.name }}
                    <span class="count-lbl">({{ option.count || 0 }})</span>
                  </mat-option>
                }
              }
              <!-- Default flat options -->
            </mat-select>
            @if (currentFilters.filters[filter.key]?.length) {
              <button
                mat-icon-button
                matSuffix
                color="primary"
                (click)="
                  currentFilters.filters[filter.key] = [];
                  $event.preventDefault();
                  $event.stopPropagation();
                  onFilter()
                "
              >
                <mat-icon>close</mat-icon>
              </button>
            }
          </mat-form-field>
        }
        <!-- Placeholder content for empty sections -->
        @if (assetClass.filters.length === 0) {
          <p>...</p>
        }
      </mat-expansion-panel>
    }
  </mat-accordion>

  @if (hasFilters) {
    <div class="mt-2 text-center">
      <button mat-button color="primary" (click)="onResetFilter()">
        Reset filters
      </button>
    </div>
  }
</div>
